import { patch } from '..';

const acceptTerms = () => patch('users/me/terms-and-conditions', { acceptTermsAndConditions: true });

export default acceptTerms;
